import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const RankInsignia = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.475 10.125L16.475 4.125C16.338 4.05 16.175 4 16 4C15.825 4 15.662 4.05 15.525 4.125L4.525 10.125C4.2 10.3 4 10.637 4 11V27C4 27.55 4.45 28 5 28C5.175 28 5.338 27.95 5.475 27.875L16 22.137L26.525 27.875C26.662 27.95 26.825 28 27 28C27.55 28 28 27.55 28 27V11C28 10.637 27.8 10.3 27.475 10.125ZM26 25.313L16.475 20.125C16.325 20.038 16.162 20 16 20C15.838 20 15.675 20.038 15.525 20.125L6 25.313V19.588L16 14.138L26 19.588V25.313V25.313ZM26 17.313L16.475 12.125C16.338 12.05 16.175 12 16 12C15.825 12 15.662 12.05 15.525 12.125L6 17.313V11.588L16 6.138L26 11.588V17.313Z" />
	</svg>
);

export default RankInsignia;
